module.exports = __webpack_public_path__ + "static/media/sprite.298ad12a.svg";